import { useRoles } from '@/hooks/auth/useRoles';
import { useAuth } from '@/hooks/useAuth';

/**
 * Thin wrapper sobre `useRoles()` para manter compatibilidade com call sites
 * existentes. Compartilha o cache `['user-roles', userId]`, eliminando RPCs
 * duplicadas em telas que também usam `useUserRoles`.
 */
export function useIsSuperAdmin() {
  const { loading: authLoading } = useAuth();
  const { isSuperAdmin, loading } = useRoles();
  return {
    isSuperAdmin,
    loading: authLoading || loading,
  };
}

